import create from 'zustand'

export type View = 'open' | 'todo' | 'closed' | ''
export type Order =
  | 'createdAsc'
  | 'createdDesc'
  | 'activityAsc'
  | 'activityDesc'

export type CustomViewType = {
  id: number
  name: string
  title: string | null
  reportedBy: number | null
  mailAccount: number | null
  status: string | null
  tags: string | null
  hidden: boolean
}

type State = {
  view: View
  customView: CustomViewType[]
  order: Order
  checkedAll: boolean
  columns: boolean
  setView: (view: View) => void
  setOrder: (order: Order) => void
  addCustomView: (customView: CustomViewType) => void
  setCustomView: (customView: CustomViewType[]) => void
  removeCustomView: (id: number) => void
  setCheckedAll: (checked: boolean) => void
  setColumns: (columns: boolean) => void
}

export const useStore = create<State>(set => ({
  view: 'open',
  customView: window.c?.views?.tickets
    ? window.c.views.tickets.map((item: CustomViewType) => ({
        ...item,
        hidden: false,
      }))
    : [],
  order: 'createdDesc',
  checkedAll: false,
  columns: true,
  setView: (view: View) => set(state => ({ view })),
  setOrder: (order: Order) => set(state => ({ order })),
  addCustomView: (customView: CustomViewType) =>
    set(state => ({ customView: [...state.customView, customView] })),
  setCustomView: (customView: CustomViewType[]) =>
    set(state => ({ customView })),
  removeCustomView: (id: number) => {
    set(state => ({
      customView: state.customView.filter(item => item.id !== id),
    }))
  },
  setCheckedAll: (checked: boolean) => set(state => ({ checkedAll: checked })),
  setColumns: (columns: boolean) => set(state => ({ columns: columns })),
}))
